import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';

@Injectable({
    providedIn: 'root'
})
export class ProfessionInsuranceRecommendationService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cr/professionInsuranceRecommendations');
    }

}
